// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2677":"GromaCoinNextSteps","3657":"GromaCoinVerify","7091":"GromaCoinWelcome","7809":"GromaCoinTransaction","8550":"GromaCoinWaitlist"}[chunkId] + "." + {"2677":"9981c520","3657":"a1b7c7c9","7091":"c44ff1e9","7809":"884913bf","8550":"69eeb52a"}[chunkId] + ".chunk.css";
};